import { twMerge } from "tailwind-merge";
import type { BaseProps, ContainerProps } from "./types";
import { Tooltip, TooltipTrigger } from "@artis/ui";
import cn from "mcn";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/pro-regular-svg-icons";

export type FormLayoutProps = BaseProps & ContainerProps;

export const FormLayout = ({ className, children, ...props }: FormLayoutProps) => {
  return (
    <div className={twMerge("flex flex-col gap-4", className)} {...props}>
      {children}
    </div>
  );
};

export type FieldSetProps = BaseProps &
  ContainerProps & {
    label?: string;
  };

export const FieldSet = ({ className, label, children, ...props }: FieldSetProps) => {
  return (
    <div className={twMerge("flex flex-col gap-1 text-[12px] leading-[18px]", className)} {...props}>
      {label && <h3 className="text-foreground text-[12px] font-medium leading-[16px]">{label}</h3>}
      {children}
    </div>
  );
};

export type FormFieldProps = BaseProps &
  ContainerProps & {
    label?: string;
    description?: string;
    tooltip?: string;
    maxWidth?: string;
  };

export const FormField = ({ className, label, description, tooltip, maxWidth, children, ...props }: FormFieldProps) => {
  return (
    <div className={twMerge("flex flex-row justify-between items-center gap-1", className)} {...props}>
      {(label || description) && (
        <div className="flex flex-col gap-px px-[6px] whitespace-nowrap">
          {label && (
            <p className="text-foreground text-[12px] font-normal leading-[18px]">
              {label}
              {tooltip && (
                <TooltipTrigger as="span" touch="toggle" focusable>
                  <span className={cn("px-1.5 py-0.5 rounded text-[12px]")}>
                    <FontAwesomeIcon icon={faCircleInfo} className="text-neutral" />
                  </span>
                  <Tooltip>{tooltip}</Tooltip>
                </TooltipTrigger>
              )}
            </p>
          )}
          {description && (
            <p
              className="text-foreground-muted text-[10.5px] font-medium leading-[15px]"
              style={{
                maxWidth: maxWidth || "100%",
                whiteSpace: maxWidth ? "break-spaces" : "unset",
              }}
            >
              {description}
            </p>
          )}
        </div>
      )}
      <div className="flex-0">{children}</div>
    </div>
  );
};
